import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'DuiUsers/List',
        method: 'post',
        data
    })
}

export const unbindApi = (data) => {
    return request({
        url: 'DuiUsers/del',
        method: 'post',
        data
    })
}
